export default __webpack_public_path__ + "static/media/2.7c1d7b74.png";